import React from "react";
import SelectionCard from "./SelectionCard";
import SampleCoverage from "../../packs/images/sample-coverage.png";

const AddSampleOnCartridge: React.FC = () => {
  return <SelectionCard heading="Check sample coverage" info="Ensure sample has spread across sensor surface." image={SampleCoverage} />;
};

export default AddSampleOnCartridge;
